/*
 * @Author: lbh
 * @Date: 2021-1-14 18:27:07
 * @LastEditors: lbh
 * @LastEditTime: 2024-06-26 12:15:22
 * @Description: file content
 */
import axios from "../../util/http";
let origin = axios.host();
let memberWeb = origin + "/member-web/api";
let riceponPay = origin + "/ricepon-pay/api";
let memberGsa = origin + "/ricepon-gsa/api";
let riceponOrder = origin + "/ricepon-order/api";
const api2C2P = origin + "/api2C2P";

const checkDefaultParams = (params) => {
  if (!params.lng) params.lng = "114.16692809506448";
  if (!params.lat) params.lat = "22.300917736946108";
  return params;
};

// 查詢用戶地址信息
export const getAddressAndResSetting = (params) =>
  axios.post(memberWeb + "/member/getAddressAndResSetting", params);
// 查詢用戶優惠券
export const getMemberCouponByMemberId = (params) =>
  axios.post(memberWeb + "/member/getMemberCouponByMemberId", params);

// 兌換優惠券
export const exchange = (params) =>
  axios.post(memberWeb + "/coupon/exchange", params);

// 查詢用戶訂單
export const getOrderList2 = (params) =>
  axios.post(memberWeb + "/order/getOrderList2", params);

/**
 * 新的 查詢訂單
 * @param {memberId,type="為空則查詢全部 1 待付款  3 點評/投票",brandId="可不傳",pageIndex,pageSize} params
 * @returns
 */
export const getMemberOrderList = (params) =>
  axios.get(`${riceponOrder}/orderInfo/getMemberOrderList`, params);

// 查詢訂單詳情
export const getOrderDetailsByOrderId = (params) =>
  axios.post(memberWeb + "/order/getOrderDetailsByOrderId", params);

// 查詢訂單 派送信息
export const calculateEstimatedTime = (params) =>
  axios.post(memberGsa + "/gsa/calculateEstimatedTime", params);

// 修改訂單狀態
export const updateOrderStatus = (params) =>
  axios.post(memberWeb + "/order/updateOrderStatus", params);

// 外送送單
export const addOrder2 = (params) =>
  axios.post(memberWeb + "/order/addOrder2", params);

// 掃碼點餐下單
export const additionalOrder = (params) =>
  axios.post(memberWeb + "/scan/additionalOrder", params);

// 自取 送單
export const takeOutAddOrder = (params) =>
  axios.post(memberWeb + "/takeOutScan/takeOutAddOrder", params);

// 查詢支付時間 和 支付方式
export const confirmPay = (params) =>
  axios.post(memberWeb + "/order/confirmPay", params);

// 查詢 訂單是否有支付
export const findOrderPayStatus = (params) =>
  axios.post(riceponPay + "/pay/findOrderPayStatus", params);

// 支付寶支付
export const transactionOpen = (params) =>
  axios.post(memberWeb + "/pay/transactionOpen", params);

// 支付寶 查詢是否支付成功
export const transactionOpenBack = (params) =>
  axios.post(memberWeb + "/pay/searchAppOpen", params);

// yedPay
export const yedPayRequest = (params) =>
  axios.post(riceponPay + "/pay/yedPayRequest", params);
// yedpay 測試 visa master
export const yedPayRequestCopy = (params) =>
  axios.post(riceponPay + "/pay/yedPayRequestCopy", params);

// yedPay 查詢是否支付成功
export const yedPayRequestBack = (params) =>
  axios.post(riceponPay + "/pay/yedPayQuery", params);

// payMe
export const payMeRequest = (params) =>
  axios.post(riceponPay + "/pay/payMeRequest", params);

// payMe 查詢是否支付成功
export const payMeRequestBack = (params) =>
  axios.post(riceponPay + "/pay/payMeRequestId", params);

// google Pay
export const googlePay = (params) =>
  axios.post(riceponPay + "/pay/googlePay", params);

// google 查詢是否支付成功
export const googlePayBack = (params) =>
  axios.post(riceponPay + "/pay/findGooglPayStatus", params);

//  apple Pay
export const stripPay = (params) =>
  axios.post(memberWeb + "/pay/stripPay", params);

// 二維碼支付
export const qrCodeApp = (params) =>
  axios.post(memberWeb + "/pay/qrCodeApp", params);

// qrcode 二維碼支付 查詢是否支付成功
export const qrCodeAppBack = (params) =>
  axios.post(memberWeb + "/pay/enquiryApp", params);

// 中銀
export const bocBillPayRequest = (params) =>
  axios.post(riceponPay + "/pay/bocBillPayRequest", params);

// 中銀 查詢是否支付成功
export const bocBillPayRequestBack = (params) =>
  axios.post(riceponPay + "/pay/bocBillPayQuery", params);

// 查詢 自取 取餐碼
export const getTakeRestInfo = (params) =>
  axios.post(memberWeb + "/takeOutScan/getTakeRestInfo", params);

/**
 * 固定碼, 授權送單接口
 * @param {
 *  memberId,
 *  restaurantId,
 *  qrCode,
 *  summaryId,
 *  foods,
 *  authCode,
 *  memberName,
 *  totalAmount,
 *  serviceAmount,
 *  serviceCharge} params
 * @returns
 */
export const addTableOrder = (params) =>
  axios.post(`${memberWeb}/qrcode/addTableOrder`, params);

/**
 * 固定碼 去支付 送單接口
 * @param {
 *  memberId,
 *  restaurantId,
 *  qrCode,
 *  summaryId,
 *  foods,
 *  foodSummary,
 *  memberName,
 *  totalAmount,
 *  serviceAmount,
 *  serviceCharge} params
 * @returns
 */
export const addTableOrder2 = (params) =>
  axios.post(`${memberWeb}/qrcode/addTableOrder2`, params);

/**
 * 錢方  微信支付  發起支付
 * @param {
 *  payTypeId 27:  QF-H5-WECHAT， 28 ： QF-PC-WECHAT
 *  restaurantId
 *  orderId
 * } params
 * @returns
 */
export const createQfPay = (params) =>
  axios.post(`${riceponPay}/qfPay/createPay`, params);

/**
 * 購買 套票
 * @param {
 *  totalAmount  金額
 *  memberId
 *  restaurantId
 *  couponPackageId 套票id
 *  orderFrom 來源
 *  num 購買數量
 * } params
 * @returns
 */
export const buyCouponGroup = (params) =>
  axios.body(`${riceponOrder}/cloudGsa/addPackageOrder`, params);

/**
 * ? 新增團購券訂單
 * @param {object} params
 * @param {number} params.restaurantId - 餐廳ID
 * @param {number} params.couponId - 優惠券ID
 * @param {number} params.num - 數量
 * @param {number} params.memberId - 會員ID
 * @param {number} params.totalAmount - 總金額
 * @param {number} params.orderFrom - 訂單來源
 * @param {number} params.orderType - 訂單類型
 * @returns {Promise}
 */
export const addGroupCouponOrder = (params) =>
  axios.body(riceponOrder + "/order/addGroupCouponOrder", params);

/**
 * 查詢 套票 訂單詳情
 * @param { orderId } params
 * @returns
 */
export const getPackageOrderById = (params) =>
  axios.get(`${riceponOrder}/packageOrder/getPackageOrderById`, params);

/**
 * yedPay web 支付
 * @param {
 *  orderId 訂單id
 *  successUrl 支付成功后跳轉的頁面（不能帶有端口）
 *  payTypeId 支付類型id  （後台支付寶傳23        h5 調用時傳32）
 * } params
 * @returns
 */
export const yedPayQrcodePay = (params) =>
  axios.post(`${riceponPay}/wechat/pay/webPay`, params);

/**
 * 自助碼 送單
 * @param {*} params
 * @returns
 */
export const serviceCodeOrder = (params) =>
  axios.post(riceponOrder + "/order/selfServiceCodeOrder", params);

/**
 * 查詢谷歌支付的支付狀態
 * @param {
 *  orderId 訂單id
 *  payTypeId 支付方式 （默認21）
 * } params
 * @returns
 */
export const findGooglePayInfo = (params) =>
  axios.get(`${riceponPay}/pay/findGooglePayInfo`, params);

// ! 支付新接口 //

/**
 * * 發起支付
 * @param {
 *  orderId 是 11167641 訂單id
 *  payTypeId 是 28 支付方式
 *  apptype 是 7 客戶端
 *  stripeToken 否  蘋果token
 *  cancelUrl 否  取消url  （GooglePay、OpenRice）
 *  successUrl 否  成功後的跳轉url  （yed Pay 、GooglePay、OpenRice） 客戶端
 * } params
 * @returns
 */
export const online_payment = (params, headers) =>
  axios.post(`${riceponPay}/onlinePayment/payment`, params, headers);

/**
 * * 支付查詢
 * @param {
 *  orderId 是 11167641 訂單id
 * } params
 * @returns
 */
export const online_query = (params) =>
  axios.get(`${riceponPay}/onlinePayment/paymentQuery`, params);

// * Allinpay Google Pay 配置
export const allinpayGooglePayConfig = (params) =>
  axios.get(`${riceponPay}/onlinePayment/allinpay/googlePayConfig`, params);

/**
 * * 支付取消
 * @param {
 *  orderId 是 11167641 訂單id
 * } params
 * @returns
 */
export const online_cancel = (params) =>
  axios.post(`${riceponPay}/onlinePayment/paymentCancelPay`, params);

/**
 * * 支付退款
 * @param {
 *  orderId 是 11167641 訂單id
 * } params
 * @returns
 */
export const online_refund = (params) =>
  axios.post(`${riceponPay}/onlinePayment/paymentRefund`, params);

// ! 2C2P 測試支付

/**
 * * 生成加密token
 * @param {
 *  "merchantID": "JT06",
 *  "invoiceNo": "10002",
 *  "description": "apple 2",
 *  "amount": 50.00,
 *  "currencyCode": "HKD",
 *  "paymentChannel": ["CC"],
 *  "secretKey":"61E900D6D1AA15A8050A4C405D001EBBF432CFCDB06B7915451E5F27C8CC2C35"
 * } params
 * @returns
 */
export const getTokenBy2c2p = (params) =>
  axios.body(`${riceponPay}/visaPay/getToken`, params);

export const aa = (params) =>
  axios.body(`https://sandbox-pgw.2c2p.com/payment/4.3/paymentToken`, params);

/**
 * * 發起支付請求
 * @param {
 *  payload
 * } params
 * @returns
 */
export const paymentTokenBy2c2p = (params) =>
  axios.body(`https://sandbox-pgw.2c2p.com/payment/4.3/paymentToken`, params);

/**
 * * 獲取支付鏈接
 * @param {
 *  secretKey
 *  payload
 * } params
 * @returns
 */
export const decryptPaymentTokenBy2c2p = (params) =>
  axios.get(`${riceponPay}/visaPay/decryptPaymentToken`, params);

// ! over

/**
 * * 修改 固定碼 已關聯人數
 * @param {
 *  * qrCode：餐桌二維碼内容
 *  * personQuantity：人數
 *  * summaryId：餐種ID
 * } params
 */
export const addScanPerson = (params) => {
  axios.post(`${riceponOrder}/qrcode/addScanPerson`, params);
};

/**
 * * 提交會員等級訂單
 * @param {*} params
 * @returns
 */
export const addBuyMemberLevelOrder = (params) =>
  axios.body(`${riceponOrder}/order/addBuyMemberLevelOrder`, params);

/**
 * ? kiosk 自主買單機 送單
 * @param {*} params
 * @returns
 */
export const kioskAddOrder = (params) =>
  axios.post(`${riceponOrder}/kiosk/kioskAddOrder`, params);



/**
 * ?  查詢 團購訂單詳情
 * @param {*} params
 * @returns
 */
export const getOrderDetail = (params) => {
  params = checkDefaultParams(params);
  return axios.get(`${riceponOrder}/orderInfo/getOrderDetail`, params);
};
